import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'excavation-trenching-for-utilities';
const serviceId = 5
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Excavation Trenching for Utilities in Sydney | ${BUSINESS_NAME}`,
        description: "Clean and accurate trenching for plumbing, electrical, and drainage installations on residential properties.",
        keywords: "excavation trenching sydney, utility trenching, plumbing trenching, electrical trenching, drainage trenching, site preparation, residential excavation, commercial excavation, custom excavation solutions, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Trenching for Utilities',
    description: 'Clean and accurate trenching for plumbing, electrical, and drainage installations on residential properties.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
